import React, { Fragment } from "react";
import { Link } from "react-router-dom";

const AboutFour = () => {
  return (
    <Fragment>
      <div className="block-style-two" data-aos="fade-left">
        <div className="title-style-one">
          <div className="sc-title-four">WHO ARE WE ?</div>
          <h2 className="main-title">
            Make solution not excuses.
          </h2>
        </div>
        {/* /.title-style-one */}
        <p className="pt-10 pb-20 lg-pb-10">
          {" "}
          Our customers come from diverse sectors like e-Commerce, Finance, Healthcare, Automobile, FMCG, Media &amp; Entertainment, and more. We have helped lots of organizations digitize to high-quality software applications. From Fortune 500 companies to fast-scaling startups, many organizations trust us to scale their offshore engineering tasks effortlessly.
        </p>
        <ul className="style-none list-item color-rev">
          <li>Various analysis options.</li>
          <li>Page Load (time, size, number of requests).</li>
          <li>Big data analysis.</li>
          <li>Adance Data analysis operation.</li>
        </ul>
        <Link to="/contact" className="btn-one mt-30">
          Contact us
        </Link>
      </div>
    </Fragment>
  );
};

export default AboutFour;
